module.exports = __webpack_public_path__ + "img/admin.560e590a.png";